import React, { useState, useEffect, useContext } from 'react';
import {IProps} from './types';
import Button from '@components/Button';
import actions from '@state/actions';
import { useDispatch, useSelector } from 'react-redux';
import selectors from '@state/selectors';
import DesignName from '../DesignName';
import Folders from '../Folders';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import * as S from './styles';
import C from '@assets/themes/colors';
const uuid = require('react-uuid');

const EditDesign:React.FC<IProps> = (props) => {

  const dispatch = useDispatch();
  const authContext = useContext(AuthContext);
  const [open, setOpen] = useState(props.open);
  const [saving, setSaving] = useState(false);
  const [userData, setUserData] = useState({
    email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
    name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
  });
  const [data, setData] = useState({
    nameDesign: {value : '', valid : false, change: false},
    folder: {value : '', id:"", valid : false, change: false, new:false},
    designAdd: {value: false, valid: false},
  } as any);
  const [dataValid, setDataValid] = useState(false);
  const folders = useSelector(selectors.folders.getFolders);

  const updateDesign = (design: any) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.updateDesign(design, "FOLDERS", (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  } 

  const addFolder = (folder: any) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.folders.addFolder(folder, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  } 

  const updateFolder = (folder: any) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.folders.updateFolder(folder, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  }

  const handleSave = async() => {
    if (dataValid && !saving) {
      setSaving(true);
      let desing = props.design;
      let oldFolder = desing.folder ? desing.folder : "";
      let update = false ;
      let indexFolderRemove = -1;
      let indexFolderAdd = -1;

      if (data.nameDesign.change) desing.name = data.nameDesign.value;
      if (data.folder.change) {
        if ( (data.folder.new && data.designAdd.value) || (!data.folder.new) ) {
          desing.folder = data.folder.id!=="" ? data.folder.id : uuid();
          update = true;
        }
      } 

      if (data.nameDesign.change || update ){
        const saveDesign :any = await updateDesign(desing);
      }

      let foldersUser = folders[0] ? folders[0] : [];
      let saved = false;

      if (data.folder.new) {
        if (foldersUser && foldersUser.length===0) {
          foldersUser = {
            id: uuid(),
            createdBy: userData,
            folders: [{ id: desing.folder, name: data.folder.value, counter: data.designAdd.value ? 1 : 0 }]
          }
          const saveFolder :any = await addFolder(foldersUser);
          saved = true;
        }
        else {
          foldersUser.folders.push( { id: desing.folder ? desing.folder: uuid(), name: data.folder.value, counter: data.designAdd.value ? 1 : 0 } );
          foldersUser.folders = foldersUser.folders.map( (folder:any) => {
            if (folder.id===oldFolder) folder.counter--;
            return folder;
          });
        }
      }
      else if (data.folder.change && data.folder.id!==oldFolder && foldersUser ) {
        foldersUser.folders = foldersUser.folders.map( (folder:any, idx:number) => {
            if (folder.id===oldFolder) {
              folder.counter--;
              indexFolderRemove = idx;
            }
            if (folder.id===data.folder.id) {
              folder.counter++;
              indexFolderAdd = idx;
            }
            return folder;
        });
      }
      
      if (!saved && data.folder.change) { const saveFolder :any = await updateFolder(foldersUser);}
      if (props.onEditMyDesigns) {
        if (indexFolderRemove!==-1 ) props.onEditMyDesigns('delete', indexFolderRemove+2);
        if (indexFolderAdd!==-1 ) props.onEditMyDesigns('add', indexFolderAdd+2);
      }
      props.setOpen(false);
    }
  }
  
  const handleData = (field: string, info: any) => setData({...data, [field] : info});

  useEffect(() => {  
    let valid = false;
    Object.keys(data).map( function(key) {
      if (data[key].valid) valid = true;
    });
    setDataValid(valid);
  }, [data]);

  return (
    <S.Root style={{
      display: open ? 'flex' : 'none',
    }} >
      <S.BoxContainer>
        <S.TitleContainer>
          <S.LeftSide>
            <S.Title>
              {props.design.name}
            </S.Title>
            <S.SubtitleContainer>
              <S.Subtitle>
              {`Created by ${props.design.createdBy?.name ? props.design.createdBy.name : "Deafault User"}, 
                ${new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(props.design.createdDate))}
              `}
              </S.Subtitle>
              <S.Hour>
              {new Intl.DateTimeFormat('en-US',{hour:'2-digit', minute:'2-digit'}).format(new Date(props.design.createdDate))}
              </S.Hour>
            </S.SubtitleContainer>
          </S.LeftSide>
        </S.TitleContainer>
        <S.Content>
          <DesignName 
              value={props.design.name} 
              fromEditDesign={true}
              userData={userData}
              handleData={handleData}
          />
          <Folders 
              name={data.nameDesign.value !=="" ? data.nameDesign.value : props.design.name } 
              folder={props.design.folder ? props.design.folder : ''} 
              userData={userData}
              handleData={handleData}
          />
        </S.Content>
        <S.ActionsContainer>
          <S.Action>
            <Button
              label="CANCEL"
              style={{
                width: '112px',
                marginRight: 12, 
                backgroundColor: "transparent", 
                border: `1px solid ${C.DARK_ORANGE}`, 
                hoverBackgroundColor: `${C.DARK_ORANGE}22`,
              }}
              labelStyle={{color: C.DARK_ORANGE}}
              onClick={() => props.setOpen(false)}
            />
          </S.Action>
          <S.Action>
            <Button
              label={ saving ? "SAVING..." : "SAVE"}
              style={{
                width: '112px',
                flexGrow: 0,
                backgroundColor: C.DARK_ORANGE, 
                hoverBackgroundColor: `${C.DARK_ORANGE}AA`,
              }} 
              onClick={handleSave}
              disabled={ !dataValid }
            />
          </S.Action>
        </S.ActionsContainer>
      </S.BoxContainer>
    </S.Root>
  );
}

export default EditDesign;